module.exports = __webpack_public_path__ + "img/181.f5881dd8.png";